var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-pull-1" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-outline-primary btn-sm",
          attrs: { type: "button" },
          on: { click: _vm.addChart }
        },
        [_c("i", { staticClass: "fa fa-plus" })]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md" },
      [
        _vm._m(0),
        _vm._v(" "),
        _vm._l(_vm.charts, function(chart) {
          return _c("oee", { key: chart.id })
        })
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "cssload-loader" }, [
      _c("div", { staticClass: "cssload-dot" }),
      _vm._v(" "),
      _c("div", { staticClass: "cssload-dot" }),
      _vm._v(" "),
      _c("div", { staticClass: "cssload-dot" }),
      _vm._v(" "),
      _c("div", { staticClass: "cssload-dot" }),
      _vm._v(" "),
      _c("div", { staticClass: "cssload-dot" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }